module.exports = {
  siteMetadata: {
    title: `Gerald Asamoah Stiftung`,
    description: `Meine Stiftung für herzkranke Kinder ist mir eine echte Herzensangelegenheit. Mit ihr unterstütze ich ausgewählte Projekte, die das Ziel haben, herzkranken Kindern zu helfen und ihr Leben wieder lebenswert zu machen.`,
    siteUrl: `https://www.gerald-asamoah-stiftung.de`,
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: "gatsby-plugin-sass",
      options: {
        useResolveUrlLoader: true,
      },
    },
    {
      resolve: `gatsby-plugin-webfonts`,
      options: {
        fonts: {
          google: [
            {
              family: `Noto Sans`,
              variants: [`400`, `400i`, `700`],
              strategy: `selfHosted`
            },
            {
              family: `Noto Serif`,
              variants: [`700`],
              strategy: `selfHosted`
            },
            {
              family: `Material Icons`,
              strategy: `selfHosted`
            }
          ],
        }
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `Gerald Asamoah Stiftung`,
        short_name: `Gerald Asamoah Stiftung`,
        display: `standalone`,
        start_url: `/`,
        background_color: `#ffffff`,
        theme_color: `#A59361`,
        icon: `src/images/asamoah-stiftung-icon.png`,
      }
    },
    {
      resolve: 'gatsby-source-storyblok',
      options: {
        accessToken: '0ow3OiVWNLXFy4mDZUKWjAtt',
        homeSlug: 'home',
        version: process.env.NODE_ENV === 'production' ? 'published' : 'draft',
        resolveRelations: ['blogpost.author', 'blogpost.relatedPosts', 'settings.top_story', 'contact.profile', 'newslist.news']
      }
    },
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        exclude: [`/`]
      }
    },
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        resolveEnv: () => process.env.GATSBY_ENV,
        env: {
          development: {
            policy: [{ userAgent: '*', disallow: ['/'] }]
          },
          production: {
            policy: [{ userAgent: '*', allow: '/' }]
          }
        }
      }
    }, {
      resolve: 'gatsby-plugin-remove-generator',
      options: {
        content: 'conducolabs/website-generator'
      }
    }
    // this (optional) plugin enables Progressive Web App + Offline functionality
    // To learn more, visit: https://gatsby.dev/offline
    // `gatsby-plugin-offline`,
  ],
}
